import styled from 'styled-components';
import { Form, Button } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { Box, Flex } from 'atoms';

export const StyledFileIcon = styled(FileTextOutlined)`
	font-size: 16px;
	color: #64748b;
	margin-right: 8px;
`;

export const PageContainer = styled(Box)`
	min-height: 100vh;
	background-color: #f8fafc;
	padding: 24px;
`;

export const ContentWrapper = styled(Box)`
	max-width: 1200px;
	margin: 0 auto;
	background: white;
	// border-radius: 12px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
	padding: 32px;
`;

export const Header = styled(Box)`
	display: flex;
	align-items: center;
	margin-bottom: 32px;
	padding-bottom: 24px;
	border-bottom: 1px solid #e5e7eb;
`;

export const BackButton = styled.button`
	background: transparent;
	border: none;
	font-size: 24px;
	color: #64748b;
	cursor: pointer;
	padding: 8px 12px;
	margin-right: 16px;
	// border-radius: 8px;
	transition: all 0.2s;

	&:hover {
		background: #f1f5f9;
		color: #1e293b;
	}
`;

export const HeaderContent = styled(Box)`
	flex: 1;
`;

export const HeaderTitle = styled.h1`
	font-size: 24px;
	font-weight: 600;
	color: #0f172a;
	margin: 0 0 4px 0;
`;

export const HeaderSubtitle = styled.p`
	font-size: 14px;
	color: #64748b;
	margin: 0;
`;

export const HeaderActions = styled(Box)`
	display: flex;
	gap: 12px;
`;

export const ActionButton = styled(Button)`
	height: 40px;
	padding: 0 24px;
	font-weight: 500;
	// border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	width: 190px;

	&.ant-btn-primary {
		background-color: #1e3a8a;
		border-color: #1e3a8a;

		&:hover {
			background-color: #1e40af !important;
			border-color: #1e40af !important;
		}
	}
`;

export const TransferButton = styled(Button)`
	height: 40px;
	padding: 0 20px;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	background: #f0f7ff;
	border: 1px solid #1990ff;
	color: #1990ff;

	&:hover {
		background: #e0f0ff !important;
		border-color: #1060cc !important;
		color: #1060cc !important;
	}
`;

export const ReplaceButton = styled(Button)`
	height: 40px;
	padding: 0 20px;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	background: #f0fff4;
	border: 1px solid #22c55e;
	color: #16a34a;

	&:hover {
		background: #dcfce7 !important;
		border-color: #15803d !important;
		color: #15803d !important;
	}
`;

export const ContractFooter = styled(Box)`
	display: flex;
	justify-content: flex-end;
	padding-top: 24px;
	margin-top: 24px;
	border-top: 1px solid #e5e7eb;
`;

export const ViewContractButton = styled(Button)`
	height: 40px;
	padding: 0 20px;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	background: #f0f7ff;
	border: 1px solid #1990ff;
	color: #1990ff;

	&:hover,
	&:focus {
		background: #e0f0ff !important;
		border-color: #1060cc !important;
		color: #1060cc !important;
	}

	&:disabled,
	&:disabled:hover {
		background: #f9fafb !important;
		border-color: #e2e8f0 !important;
		color: #b0b7c3 !important;
		cursor: not-allowed;
	}
`;

export const FormActions = styled(Box)`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	padding-top: 24px;
	margin-top: 32px;
	border-top: 1px solid #e5e7eb;
`;

export const StyledForm = styled(Form)`
	.ant-form-item-label > label {
		font-weight: 500;
		font-size: 14px;
		color: #1e293b;
		margin-bottom: 4px;
		padding-bottom: 0;
		height: 22px;
		line-height: 22px;
	}

	.ant-form-item {
		margin-bottom: 16px;
	}

	.ant-form-item-label {
		padding-bottom: 4px;
		height: 22px;
	}

	.ant-input,
	.ant-select-selector,
	.ant-picker {
		// border-radius: 6px;
		border: 1px solid #e2e8f0;
		font-size: 14px;
		height: 40px !important;
		line-height: 40px;

		&:hover {
			border-color: #94a3b8;
		}

		&:focus,
		&.ant-input-focused,
		&.ant-select-focused .ant-select-selector {
			border-color: #3b82f6;
			box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
		}
	}

	.ant-select-selector {
		height: 40px !important;
		padding: 4px 11px !important;
		display: flex !important;
		align-items: center !important;
	}

	.ant-picker {
		width: 100%;
		padding: 4px 11px;
	}

	.ant-input {
		padding: 8px 12px;
	}

	.ant-input:disabled {
		background-color: #f9fafb;
		color: #6b7280;
	}

	.ant-select-disabled .ant-select-selector {
		background-color: #f9fafb !important;
		color: #6b7280 !important;
	}

	.ant-picker-disabled {
		background-color: #f9fafb !important;
	}
`;

export const FormGrid = styled(Box)`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 24px;
	width: 100%;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

export const InlineRow = styled(Box)`
	display: flex;
	align-items: flex-start;
	gap: 24px;
	width: 100%;
`;

export const UploadButtonWrapper = styled(Box)`
	flex: 1;
	min-width: 0;
`;

export const DatePickerWrapper = styled(Box)`
	flex: 1;
	min-width: 0;
	margin-top: -25px;

	.ant-form-item {
		margin-bottom: 0;
	}
`;

export const FileDisplayContainer = styled(Flex)`
	margin-top: 8px;
	padding: 8px 12px;
	background-color: #f9fafb;
	border: 1px solid #e2e8f0;
	// border-radius: 6px;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
`;

export const FileInfo = styled(Flex)`
	align-items: center;
	gap: 8px;
	flex: 1;
	min-width: 0;
`;

export const FileIcon = styled(FileTextOutlined)`
	font-size: 18px;
	color: #dc2626;
	flex-shrink: 0;
`;

export const RemoveFileButton = styled(Box)`
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	// border-radius: 4px;
	color: #64748b;
	transition: all 0.2s;
	flex-shrink: 0;

	&:hover {
		background-color: #e2e8f0;
		color: #dc2626;
	}
`;

export const HiddenFileInput = styled.input`
	display: none !important;
	position: absolute;
	width: 0;
	height: 0;
	opacity: 0;
	pointer-events: none;
`;

export const PendingDocumentStatus = styled(Flex)`
	align-items: center;
	gap: 6px;
	color: #f59e0b;
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
`;

export const PrimaryBrowseFileButton = styled(Button)`
	height: 40px;
	padding: 0 16px;
	border: none;
	color: white;
	background-color: #1e3a8a;
	// border-radius: 6px;
	display: flex;
	align-items: center;
	gap: 8px;
	font-weight: 500;

	&:hover {
		background-color: #1e40af !important;
		color: white !important;
	}

	&:disabled {
		background-color: #e2e8f0 !important;
		color: #94a3b8 !important;
		cursor: not-allowed;
	}
`;
